<template>
	<section @click="actionGoTo" :class="['sk-navigation-link', {'sk-navigation-link--active': isActive}]" :title="title">
		<img class="sk-navigation-link__icon" :src="`/static/svg/${icon}`" alt="">
		<div class="sk-navigation-link__title">{{title}}</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-link',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: 'idicare'
		}
	},
	methods: {
		actionGoTo() {
			if (!this.route)
				return

			this.$root.$emit('navigation-close')

			this.$router.push({
				name: this.route,
				params: {
					user_uid: this.currentUser.uid
				}
			})
		}
	},
	computed: {
		isActive() {
			if (this.routeStartsWith) {
				return this.$route.name.startsWith(this.routeStartsWith)
			}
			return this.route === this.$route.name
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
	.sk-navigation-link {
		height: 64px;
		display: grid;
		grid-template-columns: 10px 64px 1fr 10px;
		align-items: center;
		border-left: 5px solid transparent;
		cursor: pointer;
		transition: border 300ms;
	}
	.sk-navigation-link:hover,
	.sk-navigation-link:active {
		background-color: rgba(255, 255, 255, 0.1);
	}

	.sk-navigation-link--active {
		border-left: 5px solid #fff;
	}

	.sk-navigation-link__icon {
		width: 32px;
		height: 32px;
		justify-self: center;
		grid-column: 2 / 3;
	}

	.sk-navigation-link__title {
		font-family: var(--font-bold);
		font-weight: normal;
		color: var(--main-font-color-invert);
		justify-self: flex-start;
		grid-column: 3 / 4;
	}

	/* @media screen and (min-width: 481px) and (max-width: 768px) {
		.sk-navigation-link {
			grid-template-columns: 64px
		}
		.sk-navigation-link__icon {
			grid-column: 1 / 2;
		}
		.sk-navigation-link__title {
			display: none;
		}
	} */
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationLink.vue